import { createSelector } from "reselect";
import moment from 'moment';

import { NumberFormat } from "common";
import { formatCurrency } from '../../helpers/formatCurrency';

export const Types = {
  GET_POINTS_PROVISION_REQUEST: "reports/GET_POINTS_PROVISION_REQUEST",
  GET_POINTS_PROVISION_SUCCESS: "reports/GET_POINTS_PROVISION_SUCCESS",
  GET_POINTS_PROVISION_FAILURE: "reports/GET_POINTS_PROVISION_FAILURE",

  EXPORT_PROVISION_POINTS_REQUEST: "reports/EXPORT_PROVISION_POINTS_REQUEST",
  EXPORT_PROVISION_POINTS_SUCCESS: "reports/EXPORT_PROVISION_POINTS_SUCCESS",
  EXPORT_PROVISION_POINTS_FAILURE: "reports/EXPORT_PROVISION_POINTS_FAILURE",

  GET_VOUCHERS_EXPENSES_REQUEST: "reports/GET_VOUCHERS_EXPENSES_REQUEST",
  GET_VOUCHERS_EXPENSES_SUCCESS: "reports/GET_VOUCHERS_EXPENSES_SUCCESS",
  GET_VOUCHERS_EXPENSES_FAILURE: "reports/GET_VOUCHERS_EXPENSES_FAILURE",

  EXPORT_VOUCHERS_EXPENSES_REQUEST: "reports/EXPORT_VOUCHERS_EXPENSES_REQUEST",
  EXPORT_VOUCHERS_EXPENSES_SUCCESS: "reports/EXPORT_VOUCHERS_EXPENSES_SUCCESS",
  EXPORT_VOUCHERS_EXPENSES_FAILURE: "reports/EXPORT_VOUCHERS_EXPENSES_FAILURE",

  GET_BENEFITS_REQUEST: "reports/GET_BENEFITS_REQUEST",
  GET_BENEFITS_SUCCESS: "reports/GET_BENEFITS_SUCCESS",
  GET_BENEFITS_FAILURE: "reports/GET_BENEFITS_FAILURE",

  EXPORT_BENEFITS_REQUEST: "reports/EXPORT_BENEFITS_REQUEST",
  EXPORT_BENEFITS_SUCCESS: "reports/EXPORT_BENEFITS_SUCCESS",
  EXPORT_BENEFITS_FAILURE: "reports/EXPORT_BENEFITS_FAILURE",

  GET_POINTS_REQUEST: "reports/GET_POINTS_REQUEST",
  GET_POINTS_SUCCESS: "reports/GET_POINTS_SUCCESS",
  GET_POINTS_FAILURE: "reports/GET_POINTS_FAILURE",

  EXPORT_POINTS_REQUEST: "reports/EXPORT_POINTS_REQUEST",
  EXPORT_POINTS_SUCCESS: "reports/EXPORT_POINTS_SUCCESS",
  EXPORT_POINTS_FAILURE: "reports/EXPORT_POINTS_FAILURE",

  GET_GENERAL_REQUEST: "reports/GET_GENERAL_REQUEST",
  GET_GENERAL_SUCCESS: "reports/GET_GENERAL_SUCCESS",
  GET_GENERAL_FAILURE: "reports/GET_GENERAL_FAILURE",

  EXPORT_GENERAL_REQUEST: "reports/EXPORT_GENERAL_REQUEST",
  EXPORT_GENERAL_SUCCESS: "reports/EXPORT_GENERAL_SUCCESS",
  EXPORT_GENERAL_FAILURE: "reports/EXPORT_GENERAL_FAILURE",

  GET_TICKETS_REQUEST: "reports/GET_TICKETS_REQUEST",
  GET_TICKETS_SUCCESS: "reports/GET_TICKETS_SUCCESS",
  GET_TICKETS_FAILURE: "reports/GET_TICKETS_FAILURE",

  EXPORT_TICKETS_REQUEST: "reports/EXPORT_TICKETS_REQUEST",
  EXPORT_TICKETS_SUCCESS: "reports/EXPORT_TICKETS_SUCCESS",
  EXPORT_TICKETS_FAILURE: "reports/EXPORT_TICKETS_FAILURE",

  GET_REGISTER_RANKING_REQUEST: "reports/GET_REGISTER_RANKING_REQUEST",
  GET_REGISTER_RANKING_SUCCESS: "reports/GET_REGISTER_RANKING_SUCCESS",
  GET_REGISTER_RANKING_FAILURE: "reports/GET_REGISTER_RANKING_FAILURE",

  EXPORT_REGISTER_RANKING_REQUEST: "reports/EXPORT_REGISTER_RANKING_REQUEST",
  EXPORT_REGISTER_RANKING_SUCCESS: "reports/EXPORT_REGISTER_RANKING_SUCCESS",
  EXPORT_REGISTER_RANKING_FAILURE: "reports/EXPORT_REGISTER_RANKING_FAILURE",

  GET_POINTS_RANKING_REQUEST: "reports/GET_POINST_RANKING_REQUEST",
  GET_POINTS_RANKING_SUCCESS: "reports/GET_POINST_RANKING_SUCCESS",
  GET_POINTS_RANKING_FAILURE: "reports/GET_POINST_RANKING_FAILURE",

  EXPORT_POINTS_RANKING_REQUEST: "reports/EXPORT_POINST_RANKING_REQUEST",
  EXPORT_POINTS_RANKING_SUCCESS: "reports/EXPORT_POINST_RANKING_SUCCESS",
  EXPORT_POINTS_RANKING_FAILURE: "reports/EXPORT_POINST_RANKING_FAILURE",

  GET_WEBPREMIOS_REQUEST: "reports/GET_WEBPREMIOS_REQUEST",
  GET_WEBPREMIOS_SUCCESS: "reports/GET_WEBPREMIOS_SUCCESS",
  GET_WEBPREMIOS_FAILURE: "reports/GET_WEBPREMIOS_FAILURE",

  EXPORT_WEBPREMIOS_REQUEST: "reports/EXPORT_WEBPREMIOS_REQUEST",
  EXPORT_WEBPREMIOS_SUCCESS: "reports/EXPORT_WEBPREMIOS_SUCCESS",
  EXPORT_WEBPREMIOS_FAILURE: "reports/EXPORT_WEBPREMIOS_FAILURE",

  EXPORT_ACCOUNTANT_REQUEST: "reports/EXPORT_ACCOUNTANT_REQUEST",
  EXPORT_ACCOUNTANT_SUCCESS: "reports/EXPORT_ACCOUNTANT_SUCCESS",
  EXPORT_ACCOUNTANT_FAILURE: "reports/EXPORT_ACCOUNTANT_FAILURE",
};

const initialState = {
  pointsProvision: {
    data: [],
    total: {
      points: 0,
      provision: 0,
    },
    loading: true,
    export: {
      loading: false,
    },
  },

  voucherExpense: {
    data: [],
    total: {
      expired: 0,
      actives: 0,
      used: 0,
    },
    loading: false,
    export: {
      loading: false,
    },
  },

  benefit: {
    data: {},
    loading: true,

    export: {
      loading: false,
    },
  },

  points: {
    data: [],
    loading: true,

    export: {
      loading: false,
    },
  },

  general: {
    data: {},
    loading: true,

    export: {
      loading: false,
    },
  },

  tickets: {
    data: {},
    loading: true,

    export: {
      loading: false,
    },
  },

  registerRanking: {
    data: [],
    loading: true,
    total: 0,

    export: {
      loading: false,
    },
  },

  pointsRanking: {
    data: [],
    loading: true,

    export: {
      loading: false,
    },
  },

  webpremios: {
    data: [],
    loading: false,

    export: {
      loading: false,
    }
  },

  accountant: {
    export: {
      loading: false,
    },
  },
};

export default function reports(state = initialState, action) {
  switch (action.type) {
    case Types.GET_POINTS_PROVISION_REQUEST:
      return {
        ...state,
        pointsProvision: {
          ...state.pointsProvision,
          loading: true,
        },
      };
    case Types.GET_POINTS_PROVISION_SUCCESS:
      return {
        ...state,
        pointsProvision: {
          ...state.pointsProvision,
          loading: false,
          data: action.payload.reports.data,
          total: {
            points: action.payload.reports.data.reduce(
              (previous, data) => previous + parseFloat(data.attributes.total),
              0
            ),
            provision: action.payload.reports.data.reduce(
              (previous, data) =>
                previous + parseFloat(data.attributes.provision),
              0
            ),
          },
        },
      };
    case Types.GET_POINTS_PROVISION_FAILURE:
      return {
        ...state,
        pointsProvision: {
          ...state.pointsProvision,
          loading: false,
        },
      };
    case Types.EXPORT_PROVISION_POINTS_REQUEST:
      return {
        ...state,
        pointsProvision: {
          ...state.pointsProvision,

          export: {
            ...state.pointsProvision.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_PROVISION_POINTS_SUCCESS:
    case Types.EXPORT_PROVISION_POINTS_FAILURE:
      return {
        ...state,
        pointsProvision: {
          ...state.pointsProvision,

          export: {
            ...state.pointsProvision.export,
            loading: false,
          },
        },
      };
    case Types.GET_VOUCHERS_EXPENSES_REQUEST:
      return {
        ...state,
        voucherExpense: {
          ...state.voucherExpense,
          loading: true,
        },
      };
    case Types.GET_VOUCHERS_EXPENSES_SUCCESS:
      return {
        ...state,
        voucherExpense: {
          ...state.voucherExpense,
          loading: false,
          data: action.payload.reports.data,
          total: {
            expired: action.payload.reports.total.expired,
            actives: action.payload.reports.total.activated,
            used: action.payload.reports.total.used
          },
        },
      };
    case Types.GET_VOUCHERS_EXPENSES_FAILURE:
      return {
        ...state,
        voucherExpense: {
          ...state.voucherExpense,
          loading: false,
        },
      };
    case Types.EXPORT_VOUCHERS_EXPENSES_REQUEST:
      return {
        ...state,
        voucherExpense: {
          ...state.voucherExpense,
          export: {
            ...state.voucherExpense.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_VOUCHERS_EXPENSES_SUCCESS:
    case Types.EXPORT_VOUCHERS_EXPENSES_FAILURE:
      return {
        ...state,
        voucherExpense: {
          ...state.voucherExpense,

          export: {
            ...state.voucherExpense.export,
            loading: false,
          },
        },
      };
    case Types.GET_BENEFITS_REQUEST:
      return {
        ...state,
        benefit: {
          ...state.benefit,
          loading: true,
        },
      };
    case Types.GET_BENEFITS_SUCCESS:
      return {
        ...state,
        benefit: {
          ...state.benefit,
          loading: false,
          data: action.payload.reports,
          total: {},
        },
      };
    case Types.GET_BENEFITS_FAILURE:
      return {
        ...state,
        benefit: {
          ...state.benefit,
          loading: false,
        },
      };
    case Types.EXPORT_BENEFITS_REQUEST:
      return {
        ...state,
        benefit: {
          ...state.benefit,
          export: {
            ...state.benefit.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_BENEFITS_SUCCESS:
    case Types.EXPORT_BENEFITS_FAILURE:
      return {
        ...state,
        benefit: {
          ...state.benefit,
          export: {
            ...state.benefit.export,
            loading: false,
          },
        },
      };
    case Types.GET_POINTS_REQUEST:
      return {
        ...state,
        points: {
          ...state.points,
          loading: true,
        },
      };
    case Types.GET_POINTS_SUCCESS:
      return {
        ...state,
        points: {
          ...state.points,
          loading: false,
          data: action.payload.reports,
        },
      };
    case Types.GET_POINTS_FAILURE:
      return {
        ...state,
        points: {
          ...state.points,
          loading: false,
        },
      };
    case Types.EXPORT_POINTS_REQUEST:
      return {
        ...state,
        points: {
          ...state.points,
          export: {
            ...state.points.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_POINTS_SUCCESS:
    case Types.EXPORT_POINTS_FAILURE:
      return {
        ...state,
        points: {
          ...state.points,
          export: {
            ...state.points.export,
            loading: false,
          },
        },
      };
    case Types.GET_GENERAL_REQUEST:
      return {
        ...state,
        general: {
          ...state.general,
          loading: true,
        },
      };
    case Types.GET_GENERAL_SUCCESS:
      return {
        ...state,
        general: {
          ...state.general,
          loading: false,
          data: action.payload.reports,
          total: {},
        },
      };
    case Types.GET_GENERAL_FAILURE:
      return {
        ...state,
        general: {
          ...state.general,
          loading: false,
        },
      };
    case Types.EXPORT_GENERAL_REQUEST:
      return {
        ...state,
        general: {
          ...state.general,
          export: {
            ...state.general.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_GENERAL_SUCCESS:
    case Types.EXPORT_GENERAL_FAILURE:
      return {
        ...state,
        general: {
          ...state.general,
          export: {
            ...state.general.export,
            loading: false,
          },
        },
      };
    case Types.GET_TICKETS_REQUEST:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          loading: true,
        },
      };
    case Types.GET_TICKETS_SUCCESS:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          loading: false,
          data: action.payload.reports,
          total: {},
        },
      };
    case Types.GET_TICKETS_FAILURE:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          loading: false,
        },
      };
    case Types.EXPORT_TICKETS_REQUEST:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          export: {
            ...state.tickets.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_TICKETS_SUCCESS:
    case Types.EXPORT_TICKETS_FAILURE:
      return {
        ...state,
        tickets: {
          ...state.tickets,
          export: {
            ...state.tickets.export,
            loading: false,
          },
        },
      };
    case Types.GET_REGISTER_RANKING_REQUEST:
      return {
        ...state,
        registerRanking: {
          ...state.registerRanking,
          loading: true,
          total: 0,
        },
      };
    case Types.GET_REGISTER_RANKING_SUCCESS:
      return {
        ...state,
        registerRanking: {
          ...state.registerRanking,
          loading: false,
          data: action.payload.reports,
          total: action.payload.reports.reduce(
            (total, current) => total + (current.full_quantity || 0),
            0
          ),
        },
      };
    case Types.GET_REGISTER_RANKING_FAILURE:
      return {
        ...state,
        registerRanking: {
          ...state.registerRanking,
          loading: false,
          total: 0,
        },
      };
    case Types.EXPORT_REGISTER_RANKING_REQUEST:
      return {
        ...state,
        registerRanking: {
          ...state.registerRanking,
          export: {
            ...state.registerRanking.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_REGISTER_RANKING_SUCCESS:
    case Types.EXPORT_REGISTER_RANKING_FAILURE:
      return {
        ...state,
        registerRanking: {
          ...state.registerRanking,
          export: {
            ...state.registerRanking.export,
            loading: false,
          },
        },
      };
    case Types.GET_POINTS_RANKING_REQUEST:
      return {
        ...state,
        pointsRanking: {
          ...state.pointsRanking,
          loading: true,
        },
      };
    case Types.GET_POINTS_RANKING_SUCCESS:
      return {
        ...state,
        pointsRanking: {
          ...state.pointsRanking,
          loading: false,
          data: action.payload.reports,
        },
      };
    case Types.GET_POINTS_RANKING_FAILURE:
      return {
        ...state,
        pointsRanking: {
          ...state.pointsRanking,
          loading: false,
        },
      };
    case Types.EXPORT_POINTS_RANKING_REQUEST:
      return {
        ...state,
        pointsRanking: {
          ...state.pointsRanking,
          export: {
            ...state.pointsRanking.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_POINTS_RANKING_SUCCESS:
    case Types.EXPORT_POINTS_RANKING_FAILURE:
      return {
        ...state,
        pointsRanking: {
          ...state.pointsRanking,
          export: {
            ...state.pointsRanking.export,
            loading: false,
          },
        },
      };
    case Types.GET_WEBPREMIOS_REQUEST:
      return {
        ...state,
        webpremios: {
          ...state.webpremios,
          loading: true,
        },
      };
    case Types.GET_WEBPREMIOS_SUCCESS:
      return {
        ...state,
        webpremios: {
          ...state.webpremios,
          loading: false,
          data: action.payload.reports,
        },
      };
    case Types.GET_WEBPREMIOS_FAILURE:
      return {
        ...state,
        webpremios: {
          ...state.webpremios,
          loading: false,
        },
      };
    case Types.EXPORT_WEBPREMIOS_REQUEST:
      return {
        ...state,
        webpremios: {
          ...state.webpremios,
          export: {
            ...state.webpremios.export,
            loading: true,
          }
        }
      };
    case Types.EXPORT_WEBPREMIOS_SUCCESS:
    case Types.EXPORT_WEBPREMIOS_FAILURE:
      return {
        ...state,
        webpremios: {
          ...state.webpremios,
          export: {
            ...state.webpremios.export,
            loading: false
          }
        }
      };
    case Types.EXPORT_ACCOUNTANT_REQUEST:
      return {
        ...state,
        accountant: {
          ...state.accountant,
          export: {
            ...state.accountant.export,
            loading: true,
          },
        },
      };
    case Types.EXPORT_ACCOUNTANT_SUCCESS:
    case Types.EXPORT_ACCOUNTANT_FAILURE:
      return {
        ...state,
        accountant: {
          ...state.accountant,
          export: {
            ...state.accountant.export,
            loading: false,
          },
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getReportPointsProvisionRequest: (filters = null) => ({
    type: Types.GET_POINTS_PROVISION_REQUEST,
    payload: { filters },
  }),

  getReportPointsProvisionSuccess: (reports) => ({
    type: Types.GET_POINTS_PROVISION_SUCCESS,
    payload: { reports },
  }),

  getReportPointsProvisionFailure: () => ({
    type: Types.GET_POINTS_PROVISION_FAILURE,
  }),

  exportReportProvisionPointsRequest: (filters = null) => ({
    type: Types.EXPORT_PROVISION_POINTS_REQUEST,
    payload: { filters },
  }),

  exportReportProvisionPointsSuccess: () => ({
    type: Types.EXPORT_PROVISION_POINTS_SUCCESS,
  }),

  exportReportProvisionPointsFailure: () => ({
    type: Types.EXPORT_PROVISION_POINTS_FAILURE,
  }),

  getReportVouchersExpensesRequest: (filters = null) => ({
    type: Types.GET_VOUCHERS_EXPENSES_REQUEST,
    payload: { filters },
  }),

  getReportVouchersExpensesSuccess: (reports) => ({
    type: Types.GET_VOUCHERS_EXPENSES_SUCCESS,
    payload: { reports },
  }),

  getReportVouchersExpensesFailure: () => ({
    type: Types.GET_VOUCHERS_EXPENSES_FAILURE,
  }),

  exportReportVouchersExpensesRequest: (filters = null) => ({
    type: Types.EXPORT_VOUCHERS_EXPENSES_REQUEST,
    payload: { filters },
  }),

  exportReportVouchersExpensesSuccess: () => ({
    type: Types.EXPORT_VOUCHERS_EXPENSES_SUCCESS,
  }),

  exportReportVouchersExpensesFailure: () => ({
    type: Types.EXPORT_VOUCHERS_EXPENSES_FAILURE,
  }),

  getReportBenefitsRequest: (filters = null) => ({
    type: Types.GET_BENEFITS_REQUEST,
    payload: { filters },
  }),

  getReportBenefitsSuccess: (reports) => ({
    type: Types.GET_BENEFITS_SUCCESS,
    payload: { reports },
  }),

  getReportBenefitsFailure: () => ({
    type: Types.GET_BENEFITS_FAILURE,
  }),

  exportReportBenefitRequest: (filters = null) => ({
    type: Types.EXPORT_BENEFITS_REQUEST,
    payload: { filters },
  }),

  exportReportBenefitSuccess: () => ({
    type: Types.EXPORT_BENEFITS_SUCCESS,
  }),

  exportReportBenefitsFailure: () => ({
    type: Types.EXPORT_BENEFITS_FAILURE,
  }),

  getReportPointsRequest: (filters = null) => ({
    type: Types.GET_POINTS_REQUEST,
    payload: { filters },
  }),

  getReportPointsSuccess: (reports) => ({
    type: Types.GET_POINTS_SUCCESS,
    payload: { reports },
  }),

  getReportPointsFailure: () => ({
    type: Types.GET_POINTS_FAILURE,
  }),

  exportReportPointsRequest: (filters = null) => ({
    type: Types.EXPORT_POINTS_REQUEST,
    payload: { filters },
  }),

  exportReportPointsSuccess: (reports) => ({
    type: Types.EXPORT_POINTS_SUCCESS,
    payload: { reports },
  }),

  exportReportPointsFailure: () => ({
    type: Types.EXPORT_POINTS_FAILURE,
  }),

  getReportGeneralRequest: (filters = null) => ({
    type: Types.GET_GENERAL_REQUEST,
    payload: { filters },
  }),

  getReportGeneralSuccess: (reports) => ({
    type: Types.GET_GENERAL_SUCCESS,
    payload: { reports },
  }),

  getReportGeneralFailure: () => ({
    type: Types.GET_GENERAL_FAILURE,
  }),

  exportReportGeneralRequest: (filters = null) => ({
    type: Types.EXPORT_GENERAL_REQUEST,
    payload: { filters },
  }),

  exportReportGeneralSuccess: () => ({
    type: Types.EXPORT_GENERAL_SUCCESS,
  }),

  exportReportGeneralFailure: () => ({
    type: Types.EXPORT_GENERAL_FAILURE,
  }),

  getReportTicketsRequest: (filters = null) => ({
    type: Types.GET_TICKETS_REQUEST,
    payload: { filters },
  }),

  getReportTicketsSuccess: (reports) => ({
    type: Types.GET_TICKETS_SUCCESS,
    payload: { reports },
  }),

  getReportTicketsFailure: () => ({
    type: Types.GET_TICKETS_FAILURE,
  }),

  exportReportTicketsRequest: (filters = null) => ({
    type: Types.EXPORT_TICKETS_REQUEST,
    payload: { filters },
  }),

  exportReportTicketsSuccess: (blob) => ({
    type: Types.EXPORT_TICKETS_SUCCESS,
    payload: { blob },
  }),

  exportReportTicketsFailure: () => ({
    type: Types.EXPORT_TICKETS_FAILURE,
  }),

  getReportRegisterRankingRequest: (filters = null) => ({
    type: Types.GET_REGISTER_RANKING_REQUEST,
    payload: { filters },
  }),

  getReportRegisterRankingSuccess: (reports) => ({
    type: Types.GET_REGISTER_RANKING_SUCCESS,
    payload: { reports },
  }),

  getReportRegisterRankingFailure: () => ({
    type: Types.GET_REGISTER_RANKING_FAILURE,
  }),

  getReportRegiterRankingFailure: () => ({
    type: Types.GET_REGISTER_RANKING_FAILURE,
  }),

  exportReportRegisterRankingRequest: (filters = null) => ({
    type: Types.EXPORT_REGISTER_RANKING_REQUEST,
    payload: { filters },
  }),

  exportReportRegisterRankingSuccess: () => ({
    type: Types.EXPORT_REGISTER_RANKING_SUCCESS,
  }),

  exportReportRegisterRankingFailure: () => ({
    type: Types.EXPORT_REGISTER_RANKING_FAILURE,
  }),

  getReportPointsRankingRequest: (filters = null) => ({
    type: Types.GET_POINTS_RANKING_REQUEST,
    payload: { filters },
  }),

  getReportPointsRankingSuccess: (reports) => ({
    type: Types.GET_POINTS_RANKING_SUCCESS,
    payload: { reports },
  }),

  getReportPointsRankingFailure: () => ({
    type: Types.GET_POINTS_RANKING_FAILURE,
  }),

  exportReportPointsRankingRequest: (filters = null) => ({
    type: Types.EXPORT_POINTS_RANKING_REQUEST,
    payload: { filters },
  }),

  exportReportPointsRankingSuccess: () => ({
    type: Types.EXPORT_POINTS_RANKING_SUCCESS,
  }),

  exportReportPointsRankingFailure: () => ({
    type: Types.EXPORT_POINTS_RANKING_FAILURE,
  }),

  getReportWebpremiosRequest: (filters = null) => ({
    type: Types.GET_WEBPREMIOS_REQUEST,
    payload: { filters },
  }),

  getReportWebpremiosSuccess: (reports) => ({
    type: Types.GET_WEBPREMIOS_SUCCESS,
    payload: { reports },
  }),

  getReportWebpremiosFailure: () => ({
    type: Types.GET_WEBPREMIOS_FAILURE,
  }),

  exportReportWebpremiosRequest: (filters = null) => ({
    type: Types.EXPORT_WEBPREMIOS_REQUEST,
    payload: { filters },
  }),

  exportReportWebpremiosSuccess: () => ({
    type: Types.EXPORT_WEBPREMIOS_SUCCESS,
  }),

  exportReportWebpremiosFailure: () => ({
    type: Types.EXPORT_WEBPREMIOS_FAILURE,
  }),

  exportReportAccountantRequest: (filters = null) => ({
    type: Types.EXPORT_ACCOUNTANT_REQUEST,
    payload: { filters },
  }),

  exportReportAccountantSuccess: () => ({
    type: Types.EXPORT_ACCOUNTANT_SUCCESS,
  }),

  exportReportAccountantFailure: () => ({
    type: Types.EXPORT_ACCOUNTANT_FAILURE,
  }),
};

export const Selectors = {
  benefits: createSelector(
    (state) => state,
    (benefits) => ({
      ...benefits,
      available_benefits: benefits.available_benefits
        ? NumberFormat(benefits.available_benefits, 0, ",", ".")
        : 0,
      reedem_benefits: benefits.reedem_benefits
        ? NumberFormat(benefits.reedem_benefits, 0, ",", ".")
        : 0,
      average_discount: benefits.average_discount
        ? `${NumberFormat(parseFloat(benefits.average_discount),2,",",".")} %`
        : 0,
      average_ticket: benefits.average_ticket
        ? NumberFormat(benefits.average_ticket, 2, ",", ".")
        : 0,
      total_value_with_benefits: benefits.total_value_with_benefits
        ? NumberFormat(benefits.total_value_with_benefits, 2, ",", ".")
        : 0,
    })
  ),

  tickets: createSelector(
    (state) => state,
    (tickets) => ({
      ...tickets,
      average_ticket: tickets.average_ticket
        ? NumberFormat(tickets.average_ticket, 2, ",", ".")
        : 0,
      amount_checkouts: tickets.amount_checkouts
        ? NumberFormat(tickets.amount_checkouts, 2, ",", ".")
        : 0,
    })
  ),

  points: createSelector(
    (state) => state,
    (points) => ({
      ...points,
      generated_points: points.generated_points
        ? Intl.NumberFormat('de-DE').format(points.generated_points)
        : 0,
      used_points: points.used_points 
        ? Intl.NumberFormat('de-DE').format(points.used_points)
        : 0,
      expired_points: points.expired_points
        ? Intl.NumberFormat('de-DE').format(points.expired_points)
        : 0,
      negative_points_webpremios: points.negative_points_webpremios
        ? Intl.NumberFormat('de-DE').format(points.negative_points_webpremios)
        : 0,
      negative_points: points.negative_points
        ? Intl.NumberFormat('de-DE').format(points.negative_points)
        : 0,
      available_points: points.available_points
        ? Intl.NumberFormat('de-DE').format(points.available_points)
        : 0,
      to_expire_points: points.to_expire_points
        ? Intl.NumberFormat('de-DE').format(points.to_expire_points)
        : 0,
      average_ticket: points.average_ticket
        ? NumberFormat(points.average_ticket, 2, ",", ".")
        : 0,
      average_unique_tickets: points.average_unique_tickets
        ? NumberFormat(points.average_unique_tickets, 2, ",", ".")
        : 0,
      total_amount: parseInt(points.total_amount),
      total_transactions: points.total_transactions
        ? Intl.NumberFormat('de-DE').format(points.total_transactions)
        : 0,
      redeem_voucher_10: points.redeem_voucher_10
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_10)
        : 0,
      redeem_voucher_30: points.redeem_voucher_30
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_30)
        : 0,
      redeem_voucher_35: points.redeem_voucher_35
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_35)
        : 0,
      redeem_voucher_75: points.redeem_voucher_75
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_75)
        : 0,
      redeem_voucher_150: points.redeem_voucher_150
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_150)
        : 0,
      redeem_voucher_175: points.redeem_voucher_175
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_175)
        : 0,
      redeem_voucher_400: points.redeem_voucher_400
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_400)
        : 0,
      redeem_voucher_750: points.redeem_voucher_750
        ? Intl.NumberFormat('de-DE').format(points.redeem_voucher_750)
        : 0,
      total_redeem_vouchers:
        Intl.NumberFormat('de-DE').format(
          parseInt(points.redeem_voucher_10) +
          parseInt(points.redeem_voucher_30) +
          parseInt(points.redeem_voucher_35) +
          parseInt(points.redeem_voucher_75) +
          parseInt(points.redeem_voucher_150) +
          parseInt(points.redeem_voucher_175) +
          parseInt(points.redeem_voucher_400) +
          parseInt(points.redeem_voucher_750)
        ),
        used_voucher_10: points.used_voucher_10
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_10)
        : 0,
      used_voucher_30: points.used_voucher_30
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_30)
        : 0,
      used_voucher_35: points.used_voucher_35
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_35)
        : 0,
      used_voucher_75: points.used_voucher_75
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_75)
        : 0,
      used_voucher_150: points.used_voucher_150
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_150)
        : 0,
      used_voucher_175: points.used_voucher_175
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_175)
        : 0,
      used_voucher_400: points.used_voucher_400
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_400)
        : 0,
      used_voucher_750: points.used_voucher_750
        ? Intl.NumberFormat('de-DE').format(points.used_voucher_750)
        : 0,
      total_used_vouchers:
        Intl.NumberFormat('de-DE').format(
          parseInt(points.used_voucher_10) +
          parseInt(points.used_voucher_30) +
          parseInt(points.used_voucher_35) +
          parseInt(points.used_voucher_75) +
          parseInt(points.used_voucher_150) +
          parseInt(points.used_voucher_175) +
          parseInt(points.used_voucher_400) +
          parseInt(points.used_voucher_750)
        ),
      customers: points.customers
        ? Intl.NumberFormat('de-DE').format(points.customers)
        : 0,
      average_redeemed_per_customer: points.average_redeemed_per_customer
        ? Intl.NumberFormat('de-DE').format(points.average_redeemed_per_customer)
        : 0,
      customers_with_used_vouchers: points.customers_with_used_vouchers
        ? Intl.NumberFormat('de-DE').format(points.customers_with_used_vouchers)
        : 0,
      average_used_per_customer: points.average_used_per_customer
        ? Intl.NumberFormat('de-DE').format(points.average_used_per_customer)
        : 0,
    })
  ),

  pointsRanking: createSelector(
    (state) => state,
    (ranking) =>
      ranking.map((data) => ({
        ...data,
        amount: data.point_quantity
          ? data.point_quantity
          : data.average_amount_paid
          ? `R$ ${NumberFormat(data.average_amount_paid, 2, ",", ".")}`
          : data.used_voucher_quantity,
      }))
  ),

  webpremios: createSelector(
    (state) => state,
    (webpremio) =>
      webpremio.map((data) => ({
        ...data,
        external_id: data.externalId,
        parent_order_id: data.parentOrderId,
        created_at: moment(data.createdAt).format('DD/MM/yyyy'),
        devolution: data.points >= 0 ? data.points : null,
        points: data.points < 0 ? data.points : null,
        total: formatCurrency(data.total),
      }))
  ),
};
